'use client';

import { useCart } from '@modules/common/components/cart-provider';
import CartMismatchBanner from './index';

export default function CartMismatchBannerClient() {
  const { snapshot } = useCart();

  if (!snapshot.hasCustomerAndCart) {
    return null;
  }

  return <CartMismatchBanner cartCustomerId={snapshot.cartCustomerId} />;
}
